export const MARKETING = 'marketing';
export const SALES = 'sales';
export const SERVICE = 'service';
export const CMS = 'cms';
export const CONTENT = 'content';
export const OPERATIONS = 'operations';
export const CRM = 'crm';
export const SUITE = 'suite';
export const BUNDLE = 'bundle';
export const COMMERCE = 'commerce';
export const MARKETING_PLUS = 'marketing-plus';
export const SPLASH = 'splash';
export const AllRoutes = [MARKETING, SALES, SERVICE, CMS, CONTENT, OPERATIONS, CRM, SUITE, BUNDLE, COMMERCE, MARKETING_PLUS, SPLASH];